export default "__VITE_ASSET__Bz3u0U_0__"